// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3jXs8";
export { _1 as "__esModule", _2 as "mobile", _3 as "root" }
export default { "__esModule": _1, "mobile": _2, "root": _3 }
